// extracted by mini-css-extract-plugin
var _1 = "Area_linkedIcon__beda7";
var _2 = "Area_toolbars__b8a3b";
export { _1 as "linkedIcon", _2 as "toolbars" }
